module.exports = __webpack_public_path__ + "img/category-popular.52d3ede1.png";